/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Thu May 04 2023
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import CardComp from "./CardComp";

const Content = styled(CardComp.Content)``;

const Layout = styled<typeof CardComp.Layout>(CardComp.Layout)`
	display: inline-flex;
	border-radius: 8px;
	overflow: hidden;

	${({ type }) =>
		type === "inner" &&
		css`
			position: relative;

			.card__content {
				position: absolute;
			}
		`}
`;

const Image = styled(CardComp.Image)`
	pointer-events: none;
`;

const Card = {
	Layout,
	Image,
	Content
};

export default Card;
